import React from "react";
import { accept, approved, pending, rejected } from "../../assets/imagesPath";

const StatsCard = ({ title, value, type }) => {
  const colors = {
    total: { bullet: "bg-[#38E1FA]", text: "text-[#1E293B]", image: accept },
    approved: {
      bullet: "bg-green-500",
      text: "text-green-500",
      image: approved,
    },
    pending: {
      bullet: "bg-yellow-500",
      text: "text-yellow-500",
      image: pending,
    },
    rejected: {
      bullet: "bg-[#38E1FA]",
      text: "text-[#38E1FA]",
      image: rejected,
    },
    default: { bullet: "bg-[#38E1FA]", text: "text-[#173363]", image: accept },
  };

  const { bullet, text, image } = colors[type] || colors.default;

  return (
    <div className="bg-[#F5F5F58A] p-6 rounded-[1.75rem] shadow-sm">
      <div className="flex items-center space-x-3 mb-4">
        <div className={`w-3 h-3 rounded-full ${bullet}`} />
        <span className={`text-lg font-medium ${text}`}>{title}</span>
      </div>
      <div className="flex items-center justify-between">
        <span className="text-2xl font-bold text-gray-900">{value}</span>
        <img
          src={image}
          alt="StatsImage"
          className="w-16 h-12 object-contain"
        />
      </div>
    </div>
  );
};

export default StatsCard;
